module.exports = __webpack_public_path__ + "img/blueSapphire.3e1abd2.jpg";